import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { useApiQuery } from './useApiQuery';

const useEventsAggregateByTimeRange = (
  { useruuid, deviceuuid, envEventTypes, startTime, endTime, aggregateFields },
  options
) => {
  const trans = useSelector(translator);
  const userEventsApi = useSelector((state) => state.apis.userEventsApi);

  return useApiQuery(
    [
      'eventsAggregateByTimeRange',
      useruuid,
      deviceuuid,
      startTime,
      endTime,
      envEventTypes?.join(','),
      JSON.stringify(aggregateFields || []),
    ],
    () =>
      new Promise((resolve, reject) => {
        userEventsApi.userEventsAggregateByTimeRange(
          useruuid,
          startTime,
          endTime,
          'daily',
          {
            eventtypes: envEventTypes,
            deviceuuid: [deviceuuid],
            fields: aggregateFields || [{ name: 'active', values: ['true'] }],
            aggregate: ['sum', 'average'],
          },
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              resolve(data?.aggregations || {});
            },
            errorCallback: () => {
              reject({});
            },
            failCallback: () => {
              reject({});
            },
          })
        );
      }),
    {
      enabled:
        !!useruuid &&
        !!deviceuuid &&
        !!startTime &&
        !!endTime &&
        Array.isArray(envEventTypes) &&
        envEventTypes.length > 0,
      ...options,
    }
  );
};

export default useEventsAggregateByTimeRange;
